import { Button } from '@/components/ui/button'

const RevenueBreakdownPreview = ({
  financialSettings,
  onSave,
  onReset,
  isSaving,
}: {
  financialSettings: any
  onSave: () => void
  onReset: () => void
  isSaving: boolean
}) => {
  const orderSubtotal = 100
  const serviceCharge =
    (orderSubtotal * parseFloat(financialSettings.service_charge_percentage)) /
    100
  const deliveryFee =
    (orderSubtotal * parseFloat(financialSettings.delivery_charge_percentage)) /
    100
  const tax = (orderSubtotal * parseFloat(financialSettings.tax_rate)) / 100
  const customerTotal = orderSubtotal + serviceCharge + deliveryFee + tax
  const platformCommission =
    (orderSubtotal * parseFloat(financialSettings.platform_commission_rate)) /
    100
  const vendorReceives = customerTotal - platformCommission

  return (
    <div className='bg-white rounded-lg p-6 shadow-sm border border-gray-100'>
      <div className='flex items-center gap-3 mb-6'>
        <div className='w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center'>
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M2 12L6 8L9 11L14 4'
              stroke='#6B7280'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
        <h3 className='text-lg font-semibold text-gray-800'>
          Revenue Breakdown Preview
        </h3>
      </div>

      <div className='mb-6'>
        <h4 className='text-base font-medium text-gray-800 mb-4'>
          For a £100 Order
        </h4>

        <div className='space-y-3'>
          <div className='flex justify-between items-center'>
            <span className='text-sm text-gray-600'>Order Subtotal:</span>
            <span className='text-sm font-medium text-gray-800'>
              £{orderSubtotal}
            </span>
          </div>

          <div className='flex justify-between items-center'>
            <span className='text-sm text-gray-600'>
              Service Charge ({financialSettings.service_charge_percentage}%):
            </span>
            <span className='text-sm font-medium text-gray-800'>
              £{serviceCharge.toFixed(2)}
            </span>
          </div>

          <div className='flex justify-between items-center'>
            <span className='text-sm text-gray-600'>
              Delivery Fee ({financialSettings.delivery_charge_percentage}%):
            </span>
            <span className='text-sm font-medium text-gray-800'>
              £{deliveryFee.toFixed(2)}
            </span>
          </div>

          <div className='flex justify-between items-center'>
            <span className='text-sm text-gray-600'>
              Tax ({financialSettings.tax_rate}%):
            </span>
            <span className='text-sm font-medium text-gray-800'>
              £{tax.toFixed(2)}
            </span>
          </div>

          <div className='flex justify-between items-center pt-2 border-t border-gray-100'>
            <span className='text-sm font-semibold text-gray-800'>
              Customer Total:
            </span>
            <span className='text-sm font-bold text-gray-800'>
              £{customerTotal.toFixed(2)}
            </span>
          </div>

          <div className='flex justify-between items-center'>
            <span className='text-sm text-gray-600'>
              Platform Commission ({financialSettings.platform_commission_rate}
              %):
            </span>
            <span className='text-sm font-medium text-red-600'>
              -£{platformCommission.toFixed(2)}
            </span>
          </div>

          <div className='flex justify-between items-center pt-2 border-t border-gray-100'>
            <span className='text-sm font-semibold text-gray-800'>
              Vendor Receives:
            </span>
            <span className='text-sm font-bold text-green-600'>
              £{vendorReceives.toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      <div className='flex gap-3'>
        <div>
          <Button
            className='flex-1 bg-amber-600 hover:bg-amber-700 text-white font-medium py-3 px-6 rounded-lg'
            onClick={onSave}
            loading={isSaving}
            loadingText='Saving...'
            disabled={isSaving}
          >
            Save Changes
          </Button>
        </div>
        <div>
          <Button
            variant='outline'
            className='flex-1 border-gray-50 text-gray-700 font-medium py-3 px-6 rounded-lg hover:bg-gray-50'
            onClick={onReset}
            disabled={isSaving}
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RevenueBreakdownPreview
